<template>
  <div>
    <div class="primary__heading">{{ value }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "PageTitle",

  props: {
    value: {
      type: String,
      default: "",
    },
  },
});
</script>

<style scoped>
.primary__heading {
  font-size: 1.5rem;
  font-weight: bold;
  color: black;
}
</style>
